import type { AuthContextType } from "../auth/AuthContext";

const SUPPORTED_IMPORT_MARKETS = new Set(["smartstore", "gmarket", "auction", "eleventh", "lotteon", "ssgdotcom"]);

export function canAccessItemImport(auth: AuthContextType): boolean {
  const environment = import.meta.env.VITE_APP_ENV;
  return environment === "LOCAL" || environment === "DEV" || auth.isImpersonating();
}

export function canAccessItemTransfer(auth: AuthContextType): boolean {
  return auth.isImpersonating() || auth.subscriptionStatus?.allow_item_transfer === true;
}

export function hasSupportedImportShop(shops: readonly { market_site: string }[]): boolean {
  return shops.some((shop) => SUPPORTED_IMPORT_MARKETS.has(shop.market_site));
}
